import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCity } from '../../../redux/bookingSlice';

import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton
  } from '@chakra-ui/react'
import styled from 'styled-components';


  function CityModal({ isOpen, onOpen, onClose }) {

    const dispatch = useDispatch();

    const cityData = [
        {
            name: "Agra",
            url:
                "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/039/original/Agra_new.jpg",
        },
        {
            name: "Haridwar",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/023/original/Ahmedabad_b8d1eb5783c996a077aff887d35e4168.jpg?1558599488"
        },

        {
            name: "Allepy",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/103/original/Belagaum.jpg?1576578730"
        },
        {
            name: "Amritsar",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/101/original/Amritsar.jpg?1568037649"
        },
        {
            name: "Goa",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/017/original/Andaman-_-Nicobar_b5a3ba5c464968f274dfb7a98bcc4dbc.jpg?1558599551"
        },
        {
            name: "chandigarh",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/024/original/Chandigarh_72374d6c6de8b70d5b4ea5c05c59ba32.jpg?1558599669"
        },
        {
            name: "Banglore",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/001/original/Bangalore_1cf1aa53741a94edc3532f7b2b583c52.jpg?1558599565"
        },
        {
            name: "Kolkata",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/095/original/Guwahati_3adb5736296c93fec082f24b87dce70d.jpg?1558600028"
        },
        {
            name: "Belagam",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/103/original/Belagaum.jpg?1576578730"
        },
        {
            name: "manali",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/028/original/Bankok_efd1b11328e1ac61488cac98a15dc584.jpg?1558599580"
        },
        {
            name: "Ahemdabad",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/012/original/Hyderabad_e23f5904385e0c21afd0fe4b7ff698fb.jpg?1558600101"
        },
        {
            name: "Jaislmer",
            url: "https://d3vp2rl7047vsp.cloudfront.net/cities/round_images/000/000/035/original/Jaisalmer_803980ec3a977dd61c215c5fbefd3909.jpg?1558600142"
        }
    ];
    
    return (
      <>
        <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
                <Heading>
                    <Link to="/"><img src="https://d36g7qg6pk2cm7.cloudfront.net/assets/landing_page/royal_brothers_logo-229959d7727f356b2e4fc3bd9c0c527c60127d009c93989a93e2daa0b1c2d556.svg" /></Link>
                    <h3>Bike Rentals</h3>
                </Heading>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Container>
                {
                    cityData.map((city, idx)=>{
                        return(
                            <Card onClick={()=>{
                                dispatch(setCity(city.name));
                                onClose(false);
                            }}>
                                <img src={city.url} alt='' />
                                <h2>{city.name}</h2>
                            </Card>
                        );
                    })
                }
              </Container>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    )
  }

  const Heading = styled.div`
    width: 100%;
    display: flex;
    font-size: 0.9rem;
    justify-content: center;
    align-items: center;
    gap: 10px;

    img{
        width: 100px;
    }

    h3{
        border-left: 1px solid #000;
        padding: 10px;
    }
  `;

  const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    align-items: center;

    @media screen and (max-width: 700px){
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (max-width: 500px){
        grid-template-columns: repeat(2, 1fr);
    }
  `;

  const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    img{
        width: 90%;
        object-fit: cover;
        border-radius: 5px;
        overflow: hidden;
    }

    h2{
        position: relative;
        bottom: 35px;
        color: white;
    }
  `;

  export default CityModal;